import { Card, Timeline, Typography } from 'antd';
import moment from 'moment';

export interface GeneralRequestJobPostingTimelineProps {
  action: 'REQUEST_CREATED' | 'REQUEST_CANCELED' | 'STAGE_APPROVED' | 'STAGE_REJECTED';
  stage?: string;
  userName: string;
  commentary?: string;
  createdDate: string;
  timelineIcon: React.ReactNode;
}

const GeneralRequestJobPostingTimeline = ({
  action,
  stage,
  userName,
  commentary,
  createdDate,
  timelineIcon,
}: GeneralRequestJobPostingTimelineProps) => {
  let actionText = '';

  switch (action) {
    case 'REQUEST_CREATED':
      actionText = 'iniciou';
      break;
    case 'REQUEST_CANCELED':
      actionText = 'cancelou';
      break;
    case 'STAGE_APPROVED':
      actionText = 'aprovou';
      break;
    case 'STAGE_REJECTED':
      actionText = 'reprovou';
      break;
  }

  return (
    <Timeline.Item dot={timelineIcon}>
      <Card>
        <Typography.Paragraph>
          <Typography.Text type="secondary">{moment(createdDate).format('LLL')}</Typography.Text>
          <br />
          <Typography.Text>
            <Typography.Text strong>{userName} </Typography.Text>
            {actionText} {stage ? <>a etapa {stage} da requisição</> : <>a requisição</>}
          </Typography.Text>
          {!!commentary && (
            <Typography.Text>
              {' '}
              com o comentário:
              <br />
              {commentary}
            </Typography.Text>
          )}
        </Typography.Paragraph>
      </Card>
    </Timeline.Item>
  );
};

export default GeneralRequestJobPostingTimeline;
